import React from 'react';
import { FormattedMessage } from 'react-intl';

import OrderCountdown from './order/OrderCountdown';

const TopNavBarCart = ({ title, onGoPrevClick }) => (
    <div className="cart__header">
        <div className="cart__header__1">
            <h2>{onGoPrevClick
                ? <span className="me-2" onClick={onGoPrevClick}>
                    <i className="bi bi-arrow-left cursor-pointer"></i>
                </span> : ''} {title}
            </h2>
            <p className="d-sm-block mb-0"><FormattedMessage id="cart_reservation_time"/></p>
        </div>
        <div className="cart__header__2">
            <OrderCountdown/>
        </div>
    </div>
);
export default TopNavBarCart;
